class ProviderLocator extends HTMLElement {
  connectedCallback() {
    this.states = this.querySelectorAll('.provider-locator__state');
    this.counts = {};
    this.states.forEach((state) => {
      const name = state.dataset.state;
      if (!name) return;
      this.counts[name] = state.querySelectorAll('.provider-locator__practice').length;
    });

    this.svgRoot = this.querySelector('#Provider-Map_SVG');

    if (!this.svgRoot) {
      return;
    }

    this.initMap();
    this.bindAccordionSync();
  }

  initMap() {
    Object.entries(this.counts).forEach(([stateName, count]) => {
      const stateSlug = stateName.toLowerCase().replace(/\s+/g, '-');
      const statePath = this.svgRoot.querySelector(`#${CSS.escape(stateSlug)}.state, #${CSS.escape(stateSlug)}[class*="state"]`);

      if (statePath && statePath.classList.contains('state')) {
        statePath.classList.toggle('active', count > 0);
        statePath.classList.toggle('inactive', count <= 0);
        statePath.style.cursor = count > 0 ? 'pointer' : '';
      }

      let circle = Array.from(this.svgRoot.querySelectorAll('.state-circle')).find(
        (element) => element.getAttribute('data-name') === stateName
      );

      if (!circle && count > 0 && statePath) {
        circle = this.createStateCircle(statePath, stateSlug, stateName, count);
      }

      if (circle) {
        const label = circle.querySelector('text tspan');
        if (label) {
          label.textContent = String(count);
        }

        circle.style.display = count > 0 ? 'block' : 'none';
      }

      const openState = () => this.openState(stateSlug);

      if (circle) {
        circle.style.cursor = 'pointer';
        circle.addEventListener('click', openState);
      }

      if (statePath && count > 0) {
        statePath.addEventListener('click', openState);
      }
    });
  }

  createStateCircle(statePath, stateSlug, stateName, count) {
    const bbox = statePath.getBBox();
    const transformMatch = statePath.getAttribute('transform')?.match(/translate\(([-\d.]+)[ ,]+([-\d.]+)\)/);
    let tx = 0;
    let ty = 0;

    if (transformMatch) {
      tx = parseFloat(transformMatch[1]);
      ty = parseFloat(transformMatch[2]);
    }

    const centerX = bbox.x + bbox.width / 2 + tx;
    const centerY = bbox.y + bbox.height / 2 + ty;
    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'g');

    circle.setAttribute('id', `${stateSlug}-circle`);
    circle.setAttribute('class', 'state-circle');
    circle.setAttribute('data-name', stateName);
    circle.setAttribute('transform', `translate(${centerX + 30}, ${centerY})`);
    circle.innerHTML = `
      <circle cx="0" cy="0" r="21" />
      <text x="0" y="6" text-anchor="middle" font-size="18" font-weight="700">
        <tspan>${count}</tspan>
      </text>
      <g class="middle-ring" fill="none" stroke-width="1">
        <circle cx="0" cy="0" r="24" />
      </g>
      <g class="outer-ring" fill="none" stroke-width="0.5">
        <circle cx="0" cy="0" r="27" />
      </g>
    `;

    this.svgRoot.appendChild(circle);
    return circle;
  }

  openState(stateSlug) {
    const target = this.querySelector(`#${CSS.escape(stateSlug)}-locations`);

    if (!target) {
      return;
    }

    this.states.forEach((state) => {
      if (state !== target) {
        state.open = false;
      }
    });

    target.open = true;

    requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  bindAccordionSync() {
    this.states.forEach((state) => {
      state.addEventListener('toggle', () => {
        if (!state.open) {
          return;
        }

        this.states.forEach((other) => {
          if (other !== state) {
            other.open = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('provider-locator')) {
  customElements.define('provider-locator', ProviderLocator);
}
